import { IconProps } from "@models/types";

export function CircleCheckIcon({ className, width, height }: IconProps) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        viewBox="0 0 20 20"
      >
        <path d="m14.79,6.29c-.2-.2-.53-.2-.73,0l-6.32,6.32-1.8-1.78c-.1-.1-.24-.18-.37-.15-.14,0-.27.06-.37.15-.2.2-.2.53,0,.73l2.16,2.14c.1.1.23.15.36.15,0,0,0,0,0,0,0,0,0,0,0,0,.14,0,.27-.05.37-.15l6.67-6.67h0c.2-.2.2-.53,0-.73Z" />
        <path d="m10,19.72C4.64,19.72.28,15.36.28,10S4.64.28,10,.28s9.72,4.36,9.72,9.72-4.36,9.72-9.72,9.72Zm0-18.43C5.19,1.28,1.28,5.19,1.28,10s3.91,8.72,8.72,8.72,8.72-3.91,8.72-8.72S14.81,1.28,10,1.28Z" />
      </svg>
    </>
  );
}
